import OrgChart from './react/OrgChart';

export default OrgChart;
